<div class="offered-rewards-carousel">
  <div
    #viewport
    class="carousel-viewport"
    [class.dragging]="isDragging"
    (touchstart)="onPointerDown($event)"
    (touchend)="onPointerUp()"
    (touchcancel)="onPointerUp()"
    (mousedown)="onPointerDown($event)">
    <div
      class="carousel-track"
      [class.no-transition]="!transitionEnabled"
      [class.dragging]="isDragging"
      [style.transform]="trackTransform">
      <div
        class="carousel-slide"
        *ngFor="let page of pages; trackBy: trackByPageIndex">
        <app-offered-reward-card
          *ngFor="let rule of page; trackBy: trackByRuleId"
          [rule]="rule">
        </app-offered-reward-card>
      </div>
    </div>
  </div>

  <div
    class="carousel-indicators"
    *ngIf="showIndicators"
    role="tablist"
    aria-label="Reward cards pages">
    <button
      type="button"
      class="indicator"
      role="tab"
      *ngFor="let page of pages; let i = index; trackBy: trackByPageIndex"
      [class.active]="i === currentPage"
      [disabled]="i === currentPage"
      [attr.aria-label]="'Reward cards page ' + (i + 1) + ' of ' + pages.length"
      [attr.aria-selected]="i === currentPage"
      (click)="goToPage(i)">
    </button>
  </div>
</div>
